window.fonts = {
    "fonts": []
};

var addFont = document.getElementById('add-font');
var id = 0;
var idFont = 0;

var fontFamily = "";

// FONT SELECT
$('#font-config-select').fontselect({
    systemFonts: false,
    placeholderSearch: 'Type to search...',
    lookahead: 4
}).on('change', function(){
    console.log(this.value);

    fontFamily = this.value;
})

addFont.addEventListener('click', function(){
    var fontContainer = document.getElementById('font-container');

    var newFont = document.createElement('div');
    newFont.classList.add('font-settings');
    newFont.setAttribute('data-id', id);

    // Font Name
    var newFontName = document.createElement('p');
    var t = document.createTextNode('font'+id);
    newFontName.classList.add('font-name'); 
    newFontName.append(t);

    // Font Logos Container
    var newFontLogos = document.createElement('div');
    newFontLogos.classList.add('font-logos');

    // Font Edit
    var newFontEdit = document.createElement('div');
    newFontEdit.setAttribute('data-id', id); 
    newFontEdit.classList.add('font-edit'); 

    newFontEdit.addEventListener('click', function(){

        var element = this;
        idFont = element.getAttribute('data-id');

        var fontConfig = document.getElementById('font-config');
        fontConfig.classList.add('show');

        window.fonts.fonts.forEach(function(obj, i) {
            if (idFont == obj.id) {
                document.getElementById('font-config-name').value = obj.settings.name;
                document.getElementById('font-config-size').value = obj.settings.size;
                document.getElementById('font-config-line-height').value = obj.settings.lineHeight;
                

                var leftAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-left')[0];
                var centerAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-center')[0];
                var rightAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-right')[0];
                if (obj.settings.textAlign == 'left') {
                    leftAlignmentContainer.classList.add('selected');
                    centerAlignmentContainer.classList.remove('selected');
                    rightAlignmentContainer.classList.remove('selected');
                } else if (obj.settings.textAlign == 'center') {
                    leftAlignmentContainer.classList.remove('selected');
                    centerAlignmentContainer.classList.add('selected');
                    rightAlignmentContainer.classList.remove('selected');
                } else if (obj.settings.textAlign == 'right') {
                    leftAlignmentContainer.classList.remove('selected');
                    centerAlignmentContainer.classList.remove('selected');
                    rightAlignmentContainer.classList.add('selected');
                }

                var fontSelect = document.getElementsByClassName('font-select')[0];
                var fontSelectSpan = fontSelect.children[0];

                document.getElementById("color-preview-font").style.backgroundColor = obj.settings.color;

                for (var i = 0; i < window.colors.colors.length; i++) {
                    window.colors.colors[i].settings.color = window.colors.colors[i].settings.color.replace(" ", "");
                    obj.settings.color = obj.settings.color.replace(" ", "");
                    if (window.colors.colors[i].settings.color == rgbToHex(obj.settings.color)) {
                        document.getElementById("font-color-selector").value = window.colors.colors[i].settings.name;
                    } else {
                        document.getElementById("font-color-selector").value = "No Color";
                    }
                }

                fontSelectSpan.innerHTML = obj.settings.fontFamily;
                fontSelectSpan.style.fontFamily = obj.settings.fontFamily;
                fontSelectSpan.style.fontWeight = obj.settings.fontWeight;


            }
        });
    })

    // Font Remove
    var newFontRemove = document.createElement("div");
    newFontRemove.classList.add("font-remove");
    newFontRemove.setAttribute('data-id', id);
    var newRemoveFontLogo = document.createElement("div");
    newRemoveFontLogo.classList.add("font-remove-logo");
    newFontRemove.append(newRemoveFontLogo);

    newFontRemove.addEventListener('click', function() {
        var element = this;

        var idElement = element.getAttribute("data-id");

        window.fonts.fonts.forEach(function(obj, i){

            if (idElement == obj.id) {
                window.fonts.fonts.splice(i, 1);
            }
        })

        var fontConfig = document.getElementById("font-config");
        if(fontConfig.classList.contains("show")) {
            fontConfig.classList.remove("show");
        }

        element.parentNode.parentNode.remove();

        window.updateFonts();
        console.log(window.fonts.fonts);
    })

    newFont.append(newFontName);
    newFont.append(newFontLogos);
    newFontLogos.append(newFontEdit);
    newFontLogos.append(newFontRemove);
    fontContainer.append(newFont);


    var newFontJSON = {
        "id": id,
        "settings": {
            "name": "font"+id,
            "fontFamily": "ABeeZee",
            "fontWeight": "400",
            "size": "12px",
            "color": "#000000",
            "lineHeight": "auto",
            "textAlign": "left"
        }
    }

    window.fonts['fonts'].push(newFontJSON);

    id++;

    window.updateFonts();
})

// Select aligment
window.selectAligment = function(pos) {
    var leftAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-left')[0];
    var centerAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-center')[0];
    var rightAlignmentContainer = document.getElementsByClassName('font-config-alignment-element-right')[0];
    if (pos == 'left') {
        leftAlignmentContainer.classList.add('selected');
        centerAlignmentContainer.classList.remove('selected');
        rightAlignmentContainer.classList.remove('selected');
    } else if (pos == 'center') {
        leftAlignmentContainer.classList.remove('selected');
        centerAlignmentContainer.classList.add('selected');
        rightAlignmentContainer.classList.remove('selected');
    } else if (pos == 'right') {
        leftAlignmentContainer.classList.remove('selected');
        centerAlignmentContainer.classList.remove('selected');
        rightAlignmentContainer.classList.add('selected');
    }
}

// Color font fonts
window.updateColorFonts = function() {
    var colorPreview = document.getElementById('color-preview-font');
    var select = document.getElementById('font-color-selector');
    var bgContainer = document.getElementsByClassName('settings-sub-block-content-line-color-font')[0];
    select.replaceChildren();
    if (window.colors.colors.length == 0) {

        var option = document.createElement('option');
        option.value = "";
        option.text = "No Color";
        select.appendChild(option);

    } else {

        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        var option = document.createElement('option');
        option.value = "";
        option.text = "No Color";
        select.appendChild(option);
        for (const val of window.colors.colors) {
            var option = document.createElement('option');
            option.value = val.settings.name;
            option.text = val.settings.name;
            select.appendChild(option);
        }
    }
}

var select = document.getElementById('font-color-selector');
var colorPreview = document.getElementById('color-preview-font');
select.addEventListener('change', function(event) {
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {
            colorPreview.style.backgroundColor = val.settings.color;
        }
    }

    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
    } else {
        colorPreview.style.border = "transparent";
    }

})

// Save Configuration Font
var saveFontConfig = document.getElementById('font-config-save');
saveFontConfig.addEventListener('click', function() {

    var fontConfig = document.getElementById('font-config');
    fontConfig.classList.remove('show');

    var fontName = document.getElementById('font-config-name').value;
    var fontSize = document.getElementById('font-config-size').value;
    var fontLineheight = document.getElementById('font-config-line-height').value;
    var fontWeight = document.getElementById('font-config-weight').value;

    var fontAlignement;
    var fontAlignmentElements = document.getElementsByClassName('font-config-alignment-element');
    for (var el = 0; el < fontAlignmentElements.length; el++) {
        if (fontAlignmentElements[el].classList.contains('selected')) {
            if (fontAlignmentElements[el].classList.contains('font-config-alignment-element-left')) {
                fontAlignement = "left";
            } else if (fontAlignmentElements[el].classList.contains('font-config-alignment-element-center')) {
                fontAlignement = "center";
            } else if (fontAlignmentElements[el].classList.contains('font-config-alignment-element-right')) {
                fontAlignement = "rigth";
            }
        }
    }
    var fontColor = document.getElementById('color-preview-font').style.backgroundColor;
    // var fontColor = colorPreview.style.backgroundColor;

    var fontFamilySelect = applyFont(fontFamily);

    window.fonts.fonts.forEach(function(obj, i) {
        if (idFont == obj.id) {
            obj.settings.name = fontName;
            obj.settings.size = fontSize;
            obj.settings.lineHeight = fontLineheight;
            obj.settings.textAlign = fontAlignement;
            obj.settings.color = fontColor;
            obj.settings.fontFamily = fontFamilySelect.fontFamily;
            obj.settings.fontWeight = fontWeight;
        }
    });

    var fontSettings = document.getElementsByClassName('font-settings');
    for (var i = 0; i < fontSettings.length; i++) {
        var dataID = fontSettings[i].getAttribute('data-id');

        if (dataID == idFont) {
            var fontNameEdit = fontSettings[i].children[0];

            fontNameEdit.innerHTML = fontName;
            fontNameEdit.style.color = fontColor;
            fontNameEdit.style.fontSize = fontSize;
            fontNameEdit.style.textAlign = fontAlignement;
            fontNameEdit.style.fontFamily = fontFamilySelect.fontFamily;
            fontNameEdit.style.fontWeight = fontFamilySelect.fontWeight;
        }
    }

    window.updateFonts();
})

function applyFont(font) {
    console.log('You selected font: ' + font);

    window.customJSON["fonts"].push(font);

    // Replace + signs with spaces for css
    font = font.replace(/\+/g, ' ');

    // Split font into family and weight
    font = font.split(':');

    var fontFamily = font[0];
    var fontWeight = font[1] || 400;

    // Set selected font on paragraphs
    return {fontFamily:fontFamily, fontWeight:fontWeight};
}

function rgbToHex(rgb) {
    var rgb = rgb.replace("rgb(", "");
    rgb = rgb.replace(")", "");
    rgb = rgb.replace(" ", "");

    var hex = rgb.split(",");
    
    let hr = Math.max(0, Math.min(255, Math.round(hex[0]))).toString(16);
    let hg = Math.max(0, Math.min(255, Math.round(hex[1]))).toString(16);
    let hb = Math.max(0, Math.min(255, Math.round(hex[2]))).toString(16);
    return "#" + (hr.length<2?"0":"") + hr + (hg.length<2?"0":"") + hg + (hb.length<2?"0":"") + hb;
}

window.updateFonts = function() {
    // Menu
    window.updateMenuFonts();
    
    // Chat Bubble - Bot
    window.updateBotBubbleFonts();

    // Chat Bubble - User
    window.updateUserBubbleFonts();

    // Quick Reply
    window.updateQuickReplyFonts();

    // Quick Reply Hover
    window.updateQuickReplyFontsHover();

    // Link Button
    window.updateLinkButtonFonts();

    // Link Button Hover
    window.updateLinkButtonFontsHover();

    // Gallery
    window.updateGalleryTitleFonts();   // Title
    window.updateGallerySubtitleFonts(); // Subtitle
}

window.updateFonts();